export default __webpack_public_path__ + "static/media/RTR2004V_Posterior.f4b6f101.webp";